import { Component, ElementRef, Input } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
import { CookieInfoModel } from './cookieinfo.model';
import { DomSanitizer } from '@angular/platform-browser';

declare const $: any;

@Component({
  selector: 'cookieinfo-popup',
  templateUrl: './cookieinfo.component.html',
  styleUrls: ['./cookieinfo.component.css'],
})

export class CookieInfoComponent extends SiriusBaseComponent<CookieInfoModel>  {
  cookieMessage: any;
  cookieTitle: any;
  public isOpen: boolean = false;
  public closeEvent: any;
  @Input() cookieTextIn: string;
  @Input() cookieTitleIn: string;

  constructor(private el: ElementRef, private domSanitizer: DomSanitizer) {
    super();
  }

  OnInit() {
  }

  public onActionClick() {
    // TODO: Implement action click logic
  }

  //close popup
  public close() {
    this.isOpen = false;
    $('html').removeClass('dont-move-back');
    if (this.closeEvent) {
      this.closeEvent();
    }
  }

  public open(title: any, content: any) {
    this.cookieTitle = title;
    this.cookieMessage = this.domSanitizer.bypassSecurityTrustHtml(content);
    $('html').addClass('dont-move-back');
    this.isOpen = true;
  }

  public setTitleAndMessage(title: string, message: string) {
    this.cookieTitle = title;
    this.cookieMessage = this.domSanitizer.bypassSecurityTrustHtml(message);
  }
} 
